import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37" {...props}>
    <defs>
      <linearGradient
        id="logo_svg__a"
        x1="50%"
        x2="50%"
        y1=".008%"
        y2="99.992%"
      >
        <stop offset="0%" stopColor="#3FA9F5" />
        <stop offset="100%" stopColor="#00D7FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#logo_svg__a)"
        d="M36.923 18.499C36.923 8.303 28.663.034 18.48.034 8.294.034.034 8.304.034 18.5c0 10.196 8.26 18.465 18.445 18.465S36.923 28.696 36.923 18.5z"
        transform="matrix(1 0 0 -1 0 37)"
      />
      <path
        fill="#FCEE21"
        d="M18.479 7.427c-5.458 0-9.876 4.432-9.876 9.887 0 .645.052 1.023.052 1.023.069.465.507.852.98.852h17.68c.472 0 .91-.387.98-.852 0 0 .05-.387.05-1.023a9.863 9.863 0 0 0-9.866-9.887z"
      />
      <path
        d="M32.574 21.77c0 .517-.464.947-1.031.947H5.329c-.567 0-1.032-.43-1.032-.946 0-.517.465-.947 1.032-.947h26.214c.567 0 1.031.43 1.031.947zm-3.867 3.614c0 .525-.464.947-1.032.947H9.196c-.567 0-1.03-.422-1.03-.947 0-.525.463-.946 1.03-.946h18.48c.567 0 1.03.421 1.03.946zm-4.641 3.614c0 .525-.465.947-1.032.947h-9.196c-.568 0-1.032-.422-1.032-.947 0-.525.464-.946 1.032-.946h9.196c.567 0 1.032.421 1.032.946z"
        fill="#FFF"
      />
    </g>
  </svg>
);
const Memo = memo(SvgLogo);
export default Memo;
